import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';

import reducers from './reducers';

const persistConfig = {
  key: 'root',
  storage,
  // eslint-disable-next-line @stylistic/line-comment-position -- FIXME
  stateReconciler: autoMergeLevel2, // see "Merge Process" section for details.
  whitelist: ['Auth', 'Theme', 'MenuPlanners'],
};

const pReducer = persistReducer(persistConfig, reducers);

export const store = createStore(
  pReducer,
  composeWithDevTools(applyMiddleware(thunk))
);
export const persistor = persistStore(store);
